"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var DialogContext = (0, react_1.createContext)({});
if (process.env.NODE_ENV !== 'production') {
    DialogContext.displayName = 'DialogContext';
}
exports.default = DialogContext;
//# sourceMappingURL=DialogContext.js.map